export default __webpack_public_path__ + "static/media/service (1).db71edea.jpg";